import { createAsyncThunk } from '@reduxjs/toolkit';
import { Attendee } from 'src/types/types';
import { actionTypes } from 'src/redesign/features/AttendeesSidebar/store/constants';
import {
  fetchAttendeeApi,
  updateAttendeeDataApi,
} from 'src/redesign/features/AttendeesSidebar/store/api';
import { UpdateAttendeeModel } from 'src/redesign/features/AttendeesSidebar/types';

export const getAttendeeDataById = createAsyncThunk(
  actionTypes.GET_ATTENDEE_DATA,
  async (id: Attendee['id'], { getState }) => await fetchAttendeeApi(getState(), id)
);

export const updateAttendeeData = createAsyncThunk(
  actionTypes.UPDATE_ATTENDEE_DATA,
  async ({ id, data }: { id: Attendee['id']; data: UpdateAttendeeModel }, { getState }) =>
    await updateAttendeeDataApi(getState(), id, data)
);
